import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'


class ApplicationMenu extends PureComponent {

    menuList() {
        return (
            this.props.menuConfig.map((menuItem, index) =>
                <li key={index}
                    className={'spark-menu__list-item ' + (this.props.activeMenuItem === menuItem.linkName ? 'active' : '')}
                    role='menuitem'>
                    <Link to={menuItem.linkHref} className='spark-menu__list-link'>
                        {menuItem.linkName}
                    </Link>
                </li>
            )
        )
    }

    render() {
        return (
            <div className="spark-menu spark-header__menu" role="menu">
                <div className="spark-menu__header">
                    <button className="spark-menu__toggle" title="Hide Navigation">
                        <i className="spark-icon--fill spark-icon-close" />
                    </button>
                    <span className="spark-menu__title" />
                </div>
                <ul className='spark-menu__list spark-header__list spark-header__list--overflow'>
                    {this.menuList()}
                </ul>
            </div>
        )
    }
}

ApplicationMenu.propTypes = {
    activeMenuItem: PropTypes.string.isRequired,
    menuConfig: PropTypes.array.isRequired
}

export default ApplicationMenu



// WEBPACK FOOTER //
// ./src/shared/components/ApplicationMenu/index.js